<template>
	<header class="checkout-heading">
		<div class="container">
			<div class="row">
				<div class="checkout-heading__left">
					<div class="checkout-heading__arrow" @click="$emit('go-back')">
						<img src="/images/icons/step-5-icons/left-arrow.svg" alt="Go back arrow" class="m-auto">
					</div>
					<h1 class="checkout-heading__heading">
						OVERVIEW
					</h1>
				</div>
				<div class="checkout-heading__right hidden-xs">
					<affirm
						v-if="buildPrice && !POS_MODE && countryCode != 'CA'"
						:price="buildPrice"
						class="step5-financing step5-affirm"
					/>
					<paybright
						v-if="buildPrice && !POS_MODE && countryCode == 'CA'"
						:price="buildPrice"
						class="step5-financing step5-paybright"
					/>
					<checkout-price
						:build-price="buildPrice"
						class="checkout-price-top"
						@checkout="$emit('checkout', 'top')"
						@showContingencyModal="$emit('show-contingency-modal')"
					/>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import CheckoutPrice from "./checkout-price";
import Affirm from "@c/generals/affirm";
import Paybright from "@c/generals/paybright";

export default {
	name: "CheckoutHeading",
	components: {
		Affirm,
		CheckoutPrice,
		Paybright
	},
	props: {
		buildPrice: {
			type: [Number, String],
			required: true
		},
		countryCode: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss" scoped>
.checkout-heading {
	background-color: #111111;
	height: 65px;
	display: flex;
	align-items: center;
	margin-bottom: 55px;

	@media (max-width: 1200px) {
		margin-bottom: 35px;
	}

	// for the holiday-alarm-reminder
	@media (max-width: 767px) {
		.container {
			width: 100%;
			.row {
				width: 100%;
				.checkout-heading__left {
					width: 100%;
					.checkout-heading__heading {
						flex: 1;
					}
				}
			}
		}
	}

	@media (max-width: 768px) {
		padding: 0 15px;
		position: fixed;
		width: 100%;
		z-index: 1;
	}

	.container {
		@media (min-width: 1315px) {
			width: 1310px;
		}

		@media (min-width: 1200px) and (max-width: 1315px) {
			width: 1150px;
		}

		@media (min-width: 991px) and (max-width: 1030px) {
			margin-top: 5px;
		}

		@media (max-width: 768px) {
			margin-right: 0;
			margin-left: 0;
		}
	}

	.row {
		display: flex;
		align-items: center;
	}

	&__left {
		display: flex;
		align-items: center;
		margin-right: auto;
	}

	&__right {
		align-items: center;
		display: flex;
		margin-right: 10px;
	}

	&__arrow {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		width: 46px;
		border: 4px solid #680099;
		margin-right: 15px;
		cursor: pointer;

		@media (max-width: 768px) {
			margin-right: 10px;
		}
	}

	&__heading {
		margin: 0;
		color: #FFFFFF;
		font-family: 'Akkurat-Light';
		font-size: 30px;
		font-weight: 300;
		letter-spacing: 2.14px;

		@media (max-width: 768px) {
			font-size: 24px;
			letter-spacing: 1.71px;
		}
	}
}

.checkout-heading::v-deep {
	.holiday-savings-msg {
		display: none;
	}

	.annual-sales__checkout {
		display: flex;
	}

	.checkout-price__button {
		margin-right: 10px;
	}
}

.checkout-heading__left::v-deep  {
	.holiday-alarm-reminder {
		display: none;
	}

	@media (min-width: 320px) and (max-width: 480px) {
		.holiday-alarm-reminder {
			display: inline-flex;
		}

		.holiday-alarm-reminder--small {
			margin-right: -20px;
		}
	}
}
</style>

<style lang="scss">
.step5-financing {
	border: 1px solid #525252;
	border-radius: 5px;
	color: #c8c8c8;
	font-size: 12px;
	margin-right: 10px;
	padding: 2px 10px;
	text-align: center;
	width: 240px;

	&.step5-affirm {
		&:hover {
			.__affirm-logo,
			.__affirm-logo::after {
				color: #000;
			}
		}
	}

	&:hover {
		background-color: #fff;
		color: #000;
	}
}
</style>
